var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#333333",
    height: "100px",
    width: "100px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    stroke: "#333333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M351.37,343.845v-39.787h58.66V170.014h-58.66h-33.391h-15.952v-17.082h79.471V0H130.504v152.932h79.47v17.082h-15.951 h-33.391h-58.661v134.045h58.661v39.787c-37.215,9.177-64.902,42.826-64.902,82.833c0,47.047,38.275,85.321,85.32,85.321h149.898 c47.046,0,85.32-38.275,85.32-85.321C416.27,386.67,388.585,353.022,351.37,343.845z M351.37,203.405h25.268v67.262H351.37 V203.405z M163.896,119.541v-86.15h184.211v86.15H163.896z M268.634,152.932v17.082h-25.268v-17.082H268.634z M194.024,304.059 V203.405h123.954v100.654v37.299H194.024V304.059z M135.363,270.668v-67.262h25.269v67.262H135.363z M330.95,478.609H181.052 c-28.634,0-51.929-23.296-51.929-51.93s23.296-51.929,51.929-51.929H330.95c28.634,0,51.929,23.296,51.929,51.929 C382.879,455.313,359.584,478.609,330.95,478.609z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M209.81,226.192v92.383h92.383v-92.383H209.81z M268.801,285.183h-25.6v-25.6h25.6V285.183z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M203.132,384.122c-23.465,0-42.555,19.09-42.555,42.555c0,23.465,19.09,42.555,42.555,42.555 c23.465,0,42.555-19.09,42.555-42.555C245.687,403.212,226.597,384.122,203.132,384.122z M203.132,435.842 c-5.053,0-9.164-4.11-9.164-9.164s4.11-9.164,9.164-9.164s9.164,4.11,9.164,9.164S208.185,435.842,203.132,435.842z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M308.871,384.122c-23.465,0-42.555,19.09-42.555,42.555c0,23.465,19.09,42.555,42.555,42.555s42.555-19.09,42.555-42.555 C351.426,403.212,332.336,384.122,308.871,384.122z M308.871,435.842c-5.053,0-9.164-4.11-9.164-9.164s4.11-9.164,9.164-9.164 s9.164,4.11,9.164,9.164S313.924,435.842,308.871,435.842z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 217.045,
    cy: 76.466,
    r: 16.696
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 294.958,
    cy: 76.466,
    r: 16.696
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiIcon);
export default __webpack_public_path__ + "static/media/ai-icon.a06869091358a1813d64afc15d9f1673.svg";
export { ForwardRef as ReactComponent };